export function selectTranslatorStats(state) {
    return state.translator.stats;
}
export function selectTranslatorCreditNotes(state) {
    return state.translator.creditNotes;
}
export function selectTranslatorCreditNote(state) {
    return state.translator.creditNote;
}
